import React, { useContext, useMemo } from "react";
import { Doughnut } from "react-chartjs-2";
import 'chart.js/auto';
import {
    MDBCard,
    MDBCardBody,
    MDBCardTitle
} from 'mdb-react-ui-kit';
import { ViolationType } from "konect-model";
import { AppContext } from "../App";
import { VIOLATION_COLOR } from "./ViolationEntry";

interface KonectValueProps {
    konectValue : number;
}

const KonectValue = (props: KonectValueProps) => {

    const { project } = useContext(AppContext);
    const konectValue = props.konectValue

    const renderDonut = useMemo(() => {
        /////Konect Value Visualization////////////

        var borderColor = 'black';
        if (konectValue <= 33) borderColor = 'rgba(231, 76, 60, 1)';
        else if (konectValue <= 66) borderColor = 'rgba(255, 164, 46, 1)';
        else borderColor = 'rgba(46, 204, 113, 1)';

        var dot = {
            dataDoughnut: {
                datasets: [
                    {
                        //data: [props.project.konectValueK.value - 1, 2, 100 - 1 - props.project.konectValueK.value],
                        data: [konectValue, 2, 100 - konectValue],
                        backgroundColor: [
                            "rgba(0,0,0,0)",
                            borderColor,//"rgba(255,255,255,1)",
                            "rgba(0,0,0,0)",
                        ],
                        borderColor: [
                            'rgba(0, 0, 0 ,0)',
                            borderColor,
                            'rgba(0, 0, 0 ,0)'
                        ],
                        borderWidth: 1 //3

                    }]
            },

            options: {
                responsive: true,
                rotation: 225,
                circumference: 270,
                cutout: '60%', //'85%',
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        enabled: false
                    },
                },
            }
        }


        var value = {
            dataDoughnut: {
                datasets: [
                    {
                        //data: [props.project.konectValueK.value - 1, 2, 100 - 1 - props.project.konectValueK.value],
                        data: [konectValue, 100 - konectValue],
                        backgroundColor: [
                            
                            borderColor,
                            "rgba(0,0,0,0)"
                        ],
                        borderColor: [
                            borderColor,
                            "rgba(0,0,0,0)"
                        ],
                        borderWidth: 1 //3

                    }]
            },

            options: {
                responsive: true,
                rotation: 225,
                circumference: 270,
                cutout: '70%', //'85%',
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        enabled: false
                    },
                },
            }
        }

        var violations = {
            dataDoughnut: {
                datasets: [
                    {
                        //data: [props.project.konectValueK.value - 1, 2, 100 - 1 - props.project.konectValueK.value],
                        data: [konectValue],
                        backgroundColor: [
                            "rgba(0,0,0,0)"
                           
                        ],
                        borderColor: [
                            "rgba(0,0,0,0)"
                        ],
                        borderWidth: 1 //3

                    }]
            },

            options: {
                responsive: true,
                rotation: 225,
                circumference: 270,
                cutout: '90%', //'90%',
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        enabled: false
                    },
                },
            }
        }


        let gEntries = project.getIdeaboxEntriesUsedInGlyphs();
        for (const type of Object.values(ViolationType)) {
            const entries = project.violations.filter(v => v.type === type && v.importance > 0);
            if (entries.length <= 0) continue;
            let weight = 0;
            for (const v of entries) {
                weight += v.importance * v.weight;
            }
            weight /= gEntries.length
            violations.dataDoughnut.datasets[0].data.push(100 * weight);
            //violations.dataDoughnut.datasets[0].backgroundColor.push(VIOLATION_COLOR[type]);
            //violations.dataDoughnut.datasets[0].borderColor.push(VIOLATION_COLOR[type]);
            violations.dataDoughnut.datasets[0].backgroundColor.push("#80808040");
            violations.dataDoughnut.datasets[0].borderColor.push("#80808000");
        }

        return <span className="outer d-flex align-items-start justify-content-center"
            style={{ position: 'relative', width: '100%', height: '100%', paddingBottom: "2.9vh" }}>
            <span id="secondContainer" style={{ position: 'absolute', width: '90%', zIndex: 3 }}>
                <Doughnut data={value.dataDoughnut} options={value.options} />
            </span>
            <span id="secondContainer" style={{ position: 'absolute', width: '90%', zIndex: 5 }}>
                <Doughnut data={dot.dataDoughnut} options={dot.options} />
            </span>
            {
            <span id="thirdContainer" style={{ position: 'absolute', width: '90%', zIndex: 3 }}>
                <Doughnut data={violations.dataDoughnut} options={violations.options} />
            </span>}
            <span className="percent d-flex align-items-center justify-content-center" style={{
                position: 'relative', zIndex: 3,
                fontSize: '2rem', paddingTop: '40%'
            }}>
                <span className="k-value" style={{backgroundColor: borderColor}}>
                {konectValue ? konectValue.toFixed(0) : 0}%
                <div style={{fontSize: "0.5em", marginTop: "-1em"}}>{konectValue > 66 ? "good" : konectValue <= 33 ? "bad" : "okay"}</div>
                </span>
            </span>
        </span>
    }, [konectValue]);


    /**
    const renderLabel = [];
    for (const type of Object.values(ViolationType)) {
        const amount = project.violations.filter(v => v.type === type).length;
        if (amount <= 0) continue;
        renderLabel.push(
            <span className="">
            <span style={{fontWeight: "bold"}}>{amount}x </span>    
            <span className='violation-type' style={{ backgroundColor: VIOLATION_COLOR[type] }}>{type}</span>
            </span>
        ) 
    }
     */

    // The MDBRange component below might cause the <div> cannot appear as a descendant of <span> error, see: https://stackoverflow.com/a/41928635 
    return (
        <>
            <MDBCard className="border" style={{ boxShadow: "none", borderRadius: '10px', width: '100%', maxWidth: '30vw', aspectRatio: '1', textAlign: "center" }}>
                <MDBCardBody>
                    <div>
                        {renderDonut}
                    </div>
                    <MDBCardTitle>Konect<br/>Value</MDBCardTitle>
                </MDBCardBody>
            </MDBCard>
        </>
    );
}
export default KonectValue